import Kakuna from './Kakuna';

export default Kakuna;



/** WEBPACK FOOTER **
 ** ./source/014-kakuna/index.js
 **/